import {
    SIM_INFO_REQUEST,
    SIM_INFO_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    result: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case SIM_INFO_REQUEST:
            return { ...state, loading: true }
å
        case SIM_INFO_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "SIM_INFO_TAB"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};